'use client';
import { createStyles, xref, getSize, rem } from '@s7/styles';
import { isObject } from '@s7/utils';
import { IDENT } from './Button.contract.js';
import { getVariantStyles } from './style.strategies.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const paddings = {
    lg1: '4s 10s',
    md1: '3s 8s',
    sm1: '10px 6s',
    xs1: '1.5s 4s'
};
const heights = {
    lg1: 56,
    md1: 48,
    sm1: 40,
    xs1: 32
};
const labelVariation = {
    weight: 'medium',
    sizes: {
        xs1: [
            14,
            20
        ],
        sm1: [
            14,
            20
        ],
        md1: [
            16,
            24
        ],
        lg1: [
            16,
            24
        ]
    }
};
const xrefColored = xref(IDENT, 'colored');
const xclassColored = `.${xrefColored}`;
const emitStyles = (theme, { variant, color, transitionDuration, width, size, typography: _typography })=>{
    const _ref = _typography || {}, { color: _textColor } = _ref, typography = _object_without_properties_loose(_ref, [
        "color"
    ]);
    /* Если для типографики задан градиент, игнорируем цвет текста */ const textColor = isObject(_textColor) ? undefined : _textColor;
    const { container, label } = getVariantStyles(theme, {
        color,
        variant,
        textColor
    });
    const baseBorder = theme.fn.border({
        color: theme.palette.border.element,
        reset: variant !== 'outline'
    });
    const transitionStyles = theme.fn.transition({
        props: [
            'background-color',
            'color',
            'theme.fn.border',
            'box-shadow'
        ],
        fn: 'ease-in-out',
        duration: transitionDuration
    });
    const coloredOverlays = theme.fn.deriveStates(label(), 'dark');
    return _extends({}, theme.fn.typography(_extends({
        variant: labelVariation,
        size
    }, typography)), {
        padding: width ? 0 : theme.fn.space(getSize({
            size,
            sizes: paddings
        })),
        height: rem(getSize({
            size,
            sizes: heights
        }))
    }, width && {
        minWidth: width
    }, baseBorder, {
        background: container.default
    }, transitionStyles, theme.fn.focusRing({
        color: container.focus,
        styles: transitionStyles
    }), {
        borderRadius: theme.fn.borderRadius(),
        '&:hover': {
            background: variant === 'white' ? container.default : container.hover,
            [xclassColored]: {
                color: variant === 'white' && coloredOverlays.hover
            }
        },
        '&:active': {
            background: variant === 'white' ? container.default : container.active,
            [xclassColored]: {
                color: variant === 'white' && coloredOverlays.active
            }
        },
        '&:disabled,&[data-disabled=true]': _extends({
            pointerEvents: 'none',
            background: container.disabled
        }, baseBorder, {
            [xclassColored]: {
                color: label('disabled')
            }
        }),
        [xclassColored]: {
            color: label()
        }
    });
};
var useStyles = createStyles((theme, _param, _)=>{
    var { breakpoints } = _param, params = _object_without_properties_loose(_param, [
        "breakpoints"
    ]);
    return {
        root: _extends({
            boxSizing: 'border-box',
            position: 'relative',
            userSelect: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }, emitStyles(theme, params), theme.fn.responsive(breakpoints)((localParams)=>emitStyles(theme, _extends({}, params, localParams)))),
        label: {
            ref: xrefColored
        },
        icon: {
            ref: xrefColored
        },
        leftIcon: {},
        rightIcon: {}
    };
});

export { useStyles as default, xrefColored };
//# sourceMappingURL=Button.styles.js.map
